import ResponsiveHeader from '@/components/ResponsiveHeader';
import { resolveHeaderBack } from '@/lib/navigation';
import { Stack } from 'expo-router';

/**
 * Own stack, sibling of `(home)` — not nested under courses.
 * Reached by `router.push('/settings')` from the drawer / account menu, so the
 * parent history can go back even when this stack's root has no local `back`.
 * `resolveHeaderBack` covers both: back within settings (edit name → account)
 * and back out to wherever the user came from (usually courses).
 */
export default function SettingsStackLayout() {
  return (
    <Stack
      screenOptions={{
        animation: 'default',
        header: ({ navigation, options, back }) => {
          const { showBack, onBack } = resolveHeaderBack(navigation, back);
          return (
            <ResponsiveHeader
              title={(options.title as string) || ''}
              showBack={showBack}
              showBookmark={false}
              onBack={onBack}
              navItems={[
                { label: 'Explore', href: '/explore' },
                { label: 'Live', href: '/live' },
                { label: 'The Hang', href: '/library' },
              ]}
            />
          );
        },
      }}
    >
      <Stack.Screen name="index" options={{ title: '' }} />
      <Stack.Screen name="profile" options={{ title: 'Account details' }} />
      <Stack.Screen name="delete-account" options={{ title: 'Delete account' }} />
    </Stack>
  );
}
